export const HTTP_STATUS_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    SUCCESS_NO_CONTENT:204,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 400,
    SERVER_ERROR: 500,
    CACHED_RESPONSE: 700,
    UN_AUTHORIZED: 401,
  };